import { ErrorInfo, Maybe } from '@csp/csp-common-model';
import { useQuery } from '../../../common/query/hooks/useQuery';
import { IcfConfig } from '../model/IcfConfig';
import { IcfConfigService } from '../service/IcfConfigService';

type Out = {
  config: IcfConfig | undefined;
  isLoadingInitial: boolean;
  isRefreshing: boolean;
  error: Maybe<ErrorInfo>;
};

export const useIcfConfig = (): Out => {
  const {
    data: config,
    error,
    isLoadingInitial,
    isRefreshing,
  } = useQuery({ cacheKey: 'ICF_CONFIG' }, IcfConfigService.fetchFormConfiguration);

  return {
    config,
    error,
    isLoadingInitial,
    isRefreshing,
  };
};
